// src/stores/formStore.js
import { defineStore } from 'pinia';
import axios from 'axios';
const apiUrl = window.config.API_URL; 

export const useFormStore = defineStore('formStore', {
  state: () => ({
    formData: {},
    images: [], 
    layourId: null,
    templateName:null,
    encodedLocation:null,
  }),
  actions: {
    
    getFormData()
    {
        return this.formData;
    },
    getImageCount()
    {
        return this.images.length;
    },
    addImage(image) {
      this.images.push(image);
    },
    removeImage(index) {
        this.images.splice(index, 1); 
    },
    setFormData(formData) {
        this.formData = { ...formData };
        console.log('store this formdata', this.formData);
    },
    clearData() {
      this.formData = {};
      this.images = [];
    },
    
  },
});